import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a1eee1a8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "layout" }
const _hoisted_2 = { class: "layout-left" }
const _hoisted_3 = { class: "layout-right" }
const _hoisted_4 = { class: "layout-right-main" }

import { onMounted, ref } from 'vue'
import leftMenu from './components/leftMenu.vue'
import layoutHeader from './components/header.vue'

// 菜单、按钮权限

export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const screenWidth = ref<any>('')
// 菜单收缩
const isFold = ref<boolean>(false)
const isFoldFun = (val: any) => {
  isFold.value = val
}
// 切换菜单收缩
const onChangeFold = () => {
  screenWidth.value = document.body.clientWidth
  if (!isFold.value && screenWidth.value < 768) {
    isFold.value = true
  } else if (isFold.value && screenWidth.value >= 768) {
    isFold.value = false
  }
}
onMounted(() => {
  onChangeFold()
  window.addEventListener('resize', function () {
    onChangeFold()
  })
})


return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(leftMenu, { isFold: isFold.value }, null, 8, ["isFold"])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(layoutHeader, {
        isFold: isFold.value,
        "onUpdate:isFold": _cache[0] || (_cache[0] = ($event: any) => ((isFold).value = $event)),
        onIsFoldChange: isFoldFun
      }, null, 8, ["isFold"]),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_router_view)
      ])
    ])
  ]))
}
}

})